import React from "react";
import { connect } from "react-redux";
import { login } from "ducks/auth";

import {
  InputAdornment,
  IconButton,
  TextField,
  Button,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import { LoginResponse, LoginForm } from "@udok/lib/api/auth";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Icons from "components/Icon";

const style = makeStyles((theme) => ({
  root: {},
  input: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  submitBtn: { marginTop: theme.spacing(1), marginBottom: theme.spacing(2) },
}));

export interface NormalLoginFormProps {
  login: (l: LoginForm) => Promise<LoginResponse>;
  onLogin?: (r: any) => any;
}

const NormalLoginForm = (props: NormalLoginFormProps) => {
  const classes = style();
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [rememberMe, setRememberMe] = React.useState(false);
  const { slug } = useParams<{ slug: string }>();

  const handleSubmit = React.useCallback(
    (e: any) => {
      e.preventDefault();
      setLoading(true);
      props
        .login({
          email,
          password,
          clinSlug: slug,
          rememberMe,
        })
        .then((r: any) => props.onLogin && props.onLogin(r))
        .catch((e: any) => {})
        .finally(() => {
          setLoading(false);
        });
    },
    [props, email, password, slug, rememberMe]
  );

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        id="email"
        label="Email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        margin="normal"
        fullWidth
        disabled={loading}
        className={classes.input}
      />

      <TextField
        id="adornment-password"
        label="Senha"
        variant="outlined"
        fullWidth
        disabled={loading}
        type={showPassword ? "text" : "password"}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                color="primary"
                aria-label="Toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={(e) => e.preventDefault()}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        className={classes.input}
      />
      <FormControlLabel
        label="Manter-me conectado"
        control={
          <Checkbox
            checked={rememberMe}
            color="primary"
            onChange={() => setRememberMe(!rememberMe)}
            icon={<Icons.CheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<Icons.CheckBox fontSize="small" />}
          />
        }
      />
      <div>
        <Button
          className={classes.submitBtn}
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          fullWidth
        >
          <span>Login</span>
          {loading && <CircularProgress size={24} />}
        </Button>
      </div>
    </form>
  );
};

export default connect(
  () => ({}),
  (dispatch: any) => ({
    login: (d: LoginForm) => dispatch(login(d)),
  })
)(NormalLoginForm);
